/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import type {
	UseQueryOptions,
	UseQueryResult,
	UseSuspenseQueryOptions,
	UseSuspenseQueryResult,
} from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { campaignInterviewSettingsShow } from '../../axios/campaignInterviewSettingsShow'
import type {
	CampaignInterviewSettingsShowError,
	CampaignInterviewSettingsShowPathParams,
	CampaignInterviewSettingsShowResponse,
} from '../../types/CampaignInterviewSettingsShow'

export const campaignInterviewSettingsShowQueryKey = (campaign: CampaignInterviewSettingsShowPathParams['campaign']) =>
	[{ url: '/interview-scheduling/campaigns/:campaign/interview-settings', params: { campaign } }] as const

export type CampaignInterviewSettingsShowQueryKey = ReturnType<typeof campaignInterviewSettingsShowQueryKey>

/** @see backend/nexus/modules/InterviewScheduling/Http/Controllers/CampaignInterviewSettingsController.php CampaignInterviewSettingsController::show */
export function campaignInterviewSettingsShowQueryOptions(
	campaign: CampaignInterviewSettingsShowPathParams['campaign'],
	config?: AxiosRequestConfig,
) {
	return queryOptions<
		CampaignInterviewSettingsShowResponse,
		AxiosError<CampaignInterviewSettingsShowError>,
		CampaignInterviewSettingsShowResponse,
		CampaignInterviewSettingsShowQueryKey
	>({
		queryKey: campaignInterviewSettingsShowQueryKey(campaign),
		queryFn: ({ signal }) => campaignInterviewSettingsShow(campaign, { signal, ...config }).then(res => res.data),
		enabled: !!campaign,
	})
}

/** @see backend/nexus/modules/InterviewScheduling/Http/Controllers/CampaignInterviewSettingsController.php CampaignInterviewSettingsController::show */
export function useCampaignInterviewSettingsShow<TSelectData = CampaignInterviewSettingsShowResponse>(
	campaign: CampaignInterviewSettingsShowPathParams['campaign'],
	options?:
		& Partial<
			Omit<
				UseQueryOptions<
					CampaignInterviewSettingsShowResponse,
					AxiosError<CampaignInterviewSettingsShowError>,
					TSelectData,
					CampaignInterviewSettingsShowQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseQueryResult<TSelectData, AxiosError<CampaignInterviewSettingsShowError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useQuery({
		...campaignInterviewSettingsShowQueryOptions(campaign),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}

/** @see backend/nexus/modules/InterviewScheduling/Http/Controllers/CampaignInterviewSettingsController.php CampaignInterviewSettingsController::show */
export function useCampaignInterviewSettingsShowSuspense<TSelectData = CampaignInterviewSettingsShowResponse>(
	campaign: CampaignInterviewSettingsShowPathParams['campaign'],
	options?:
		& Partial<
			Omit<
				UseSuspenseQueryOptions<
					CampaignInterviewSettingsShowResponse,
					AxiosError<CampaignInterviewSettingsShowError>,
					TSelectData,
					CampaignInterviewSettingsShowQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseSuspenseQueryResult<TSelectData, AxiosError<CampaignInterviewSettingsShowError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useSuspenseQuery({
		...campaignInterviewSettingsShowQueryOptions(campaign),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}
